// Firebase web configs are public by design (not secrets).
const firebaseConfigDev = {
  apiKey: 'AIzaSyDSjLsdEj9-QJB4cFbVdcKjYq1j4YcllFA',
  authDomain: 'ezymind-app.firebaseapp.com',
  projectId: 'ezymind-app',
  storageBucket: 'ezymind-app.firebasestorage.app',
  messagingSenderId: '283931777636',
  appId: '1:283931777636:web:b99635779d342b8bea5d71',
  measurementId: 'G-2VCG3F3EYF',
};

const firebaseConfigProd = {
  apiKey: 'AIzaSyBnLmp-Li9jvRYKnB5qSydGU-5v0LEd_cU',
  authDomain: 'ezymind-app-c9805.firebaseapp.com',
  projectId: 'ezymind-app-c9805',
  storageBucket: 'ezymind-app-c9805.firebasestorage.app',
  messagingSenderId: '302117803307',
  appId: '1:302117803307:web:608caae00977f0c181e16e',
  measurementId: 'G-90GP27H9X1',
};

// CRA hard-sets NODE_ENV ('production' for every build), so deploy env is our own var.
const firebaseConfig =
  process.env.REACT_APP_ENV === 'production' ? firebaseConfigProd : firebaseConfigDev;

// Set once initFirebase resolves; consumed by getAppCheckToken.
let appCheckModule = null;
let appCheckInstance = null;

// Dynamic imports keep firebase off the critical path (and out of the initial bundle).
export const initFirebase = () => {
  if (!firebaseConfig.apiKey) return;
  Promise.all([import('firebase/app'), import('firebase/app-check'), import('firebase/analytics')])
    .then(([{ initializeApp }, appCheck, analytics]) => {
      const app = initializeApp(firebaseConfig);
      const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
      if (siteKey) {
        // Dev uses an App Check debug token (printed in the console on first run;
        // register it in Firebase console → App Check → Manage debug tokens).
        if (process.env.NODE_ENV === 'development') {
          window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
        }
        appCheckModule = appCheck;
        appCheckInstance = appCheck.initializeAppCheck(app, {
          provider: new appCheck.ReCaptchaV3Provider(siteKey),
          isTokenAutoRefreshEnabled: true,
        });
      }
      return analytics.isSupported().then((ok) => {
        if (ok) analytics.getAnalytics(app);
      });
    })
    .catch(() => {
      // Firebase is best-effort; never block the app on it.
    });
};

// Current App Check token, or null when App Check isn't configured/ready.
// getToken serves from cache and auto-refreshes, so per-request calls are cheap.
export const getAppCheckToken = async () => {
  if (!appCheckModule || !appCheckInstance) return null;
  try {
    const { token } = await appCheckModule.getToken(appCheckInstance);
    return token || null;
  } catch {
    return null;
  }
};
